import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import LoginButton from 'components/molecules/LoginButton';
import { getMigrosLoginReturnToURL, getMigrosLogoutReturnToURL } from 'helper/login';
import { actionCreators as loginAC, getIsMigrosAuthenticated, getLoginRedirectRoutePath } from 'store/login';
import { IRootState } from 'store/rootReducer';
import { actionCreators as appAC } from 'store/view';

const mapStateToProps = (state: IRootState, ownProps: any) => ({
	migrosLoginReturnToURL: getMigrosLoginReturnToURL(getLoginRedirectRoutePath(state)),
	migrosLogoutReturnToURL: getMigrosLogoutReturnToURL(),
	isMigrosAuthenticated: getIsMigrosAuthenticated(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators({ ...loginAC, ...appAC }, dispatch);
};

export type LoginButtonContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(LoginButton as any);
